import React, {  useState, useEffect } from 'react';
import { Modal, Form, Button, Row, Col } from 'react-bootstrap'
import axios from 'axios'
import Loader from '../components/Loader'
import {useSelector} from 'react-redux'
import { Map, GoogleApiWrapper, Marker} from 'google-maps-react';

const HomeScreen = (props) => {

  

  const [showModal, setShowModal] = useState(false)
  const [stub, setStub] = useState({})
  const [abr, setAbr] = useState('')
  const [num, setNum] = useState('')
  const [stubovi, setStubovi] = useState([])
  const [email, setEmail] = useState('')
  const [brojT, setBrojT] = useState('')
  const [opisK, setOpisK] = useState('')
  const [prikS, setPrikS] = useState(false)
  const [status, setStatus] = useState(false)
  const [mesto, setMesto] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [enable, setEnable] = useState(true)

  const userLogin = useSelector(state => state.userLogin)
  const { userInfo } = userLogin

  const mestoid = props.match.params.id

  useEffect(() => {
    axios.get(`/api/mesta/${mestoid}`).then(item => {
      setIsLoading(false)
      setMesto(item.data)
    })
    axios.get(`/api/stubovi/${mestoid}`).then(item => {
      setIsLoading(false)
      setStubovi(item.data)})
  }, [userInfo, mestoid])

  const iconBase =
    // "https://developers.google.com/maps/documentation/javascript/examples/full/images/";
    "http://maps.google.com/mapfiles/ms/icons/"

  const mapStyles = {
    width: '70%',
    height: '70%'
  };



  const onClickHandler = (k) => {
    setStub(k)
    setStatus(k.status)
    setEmail('')
    setBrojT('')
    setOpisK('')
    setShowModal(true)
  }

  const onCloseHandler = () => {
    setShowModal(false)
    setEnable(true)
  }

  const submitHandler = (e) => {
    e.preventDefault()
  }

  const adminHandler = () => {
    setPrikS(!prikS)
    
  }

  const statusHandler = () => {
    setStatus(!status)
  }

  // const onChange = (value) => {
  //   setEnable(true)
  //   console.log('Captctha value', value)
  // }

  const submitFormHandler = (e) => {
    e.preventDefault()
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    if(!userInfo){
      axios.post(`/api/stubovi/kvar/${stub._id}`, {email, brojT, opisK}, config)
    } else {
      axios.put(`/api/status/${stub._id}`, {status}, config)
    }
    
    setShowModal(false)
  }
   

  return (
    <>
    {isLoading && <Loader />}
    {!isLoading && <div style={{height: '40vw'}}>
     <Form onSubmit={submitHandler} inline>
       
      <Form.Control type='text' name='q' onChange={(e) => setAbr(e.target.value)} placeholder='Pretraži ulicu' className='mr-sm-2 ml-sm-5'></Form.Control>
      <Form.Control type='text' name='p' onChange={(e) => setNum(e.target.value)} placeholder='Pretraži kućni broj' className='mr-sm-2 ml-sm-5'></Form.Control>
      {userInfo && userInfo.isAdmin && <Form.Check type='checkbox' value={prikS} label='Stubovi sa kvarom' onClick={adminHandler} className='mr-sm-2 ml-sm-5' />}
      <div className='mx-5'>
      <p>Ukupan broj stubova: {stubovi.length}</p>
       <p>Ukupan broj stubova sa svetiljkama: {stubovi.reduce((acc, item) => acc + (item.svetiljka? 1: 0), 0)}</p>
      </div>
     
    </Form>
    <Row>
        <Col className='text-center' md={6}>
      Stubovi sa svetiljkom <img src='http://maps.google.com/mapfiles/ms/icons/green-dot.png' alt='ikonica' />
        </Col>
        <Col md={6}>
        Stubovi bez svetiljke <img src='http://maps.google.com/mapfiles/ms/icons/red-dot.png' alt='ikonica' />
        </Col>
      </Row>
    
  {mesto && <Map
    zoom={Number(mesto.zoom)}
    google={props.google}
    style={mapStyles}
    mapType='satellite'
    initialCenter={
      {
        lat: mesto.center.lat,
        lng: mesto.center.lon
      }
    }
  >
    {!showModal && stubovi.filter(item => ((userInfo && userInfo.isAdmin) ? prikS ? item.status === false : true : true) && item.Adresa.toUpperCase().includes(abr.toUpperCase()) && item.Adresa.split(' ').pop().toUpperCase().includes(num.toUpperCase())).map((k,index) => (
      <Marker key={k._id} position={{lat: k.LAT, lng: k.LON}} onClick={()=> onClickHandler(k)}  icon = {k.svetiljka ? iconBase + 'green-dot.png' : iconBase + 'red-dot.png' } />
    ))}
  </Map>}  

  <Modal show={showModal} onHide={onCloseHandler}>
  <Modal.Header closeButton>
    <Modal.Title>{userInfo || !stub.svetiljka ? "Info" : "Prijava kvara"}</Modal.Title>
  </Modal.Header> 
  <Modal.Body>
    <Form onSubmit={submitFormHandler}>
      <p>Broj Stuba: {stub.Rbr}</p>
      <p>Adresa: {stub.Adresa}</p>
      <p>{stub.Tekst}</p>
      {!stub.status && <h2>Za stub je vec prijavljen kvar</h2>}
      {!stub.svetiljka && <h2>Stub je bez svetiljke</h2>}
      {!userInfo && stub.svetiljka && stub.status && ( 
          <>
          <Form.Group controlId='email'>
          <Form.Label>Email</Form.Label>
          <Form.Control type='text' placeholder='Email' value={email} onChange={(e) => {setEmail(e.target.value)}} required></Form.Control>
          </Form.Group> 
          <Form.Group controlId='brojT'>
          <Form.Label>Broj telefona</Form.Label>
          <Form.Control type='text' placeholder='Broj telefona' value={brojT} onChange={(e) => {setBrojT(e.target.value)}}></Form.Control>
          </Form.Group>
          <Form.Group controlId='opisK'>
          <Form.Label>Opis kvara</Form.Label>
          <Form.Control as='textarea' row='6' placeholder='Opis Kvara' value={opisK} onChange={(e) => {setOpisK(e.target.value)}} required></Form.Control>
          </Form.Group>
          {/* <ReCAPTCHA sitekey='6LfWKq4aAAAAAFomeA02vreRs0MJL5mGbqaIkxIl' onChange={onChange} /> */}
          </>
          ) }
          {userInfo && userInfo.isAdmin && !stub.status && <Form.Check type='checkbox' value={!stub.status} label='Izmeni status' onClick={statusHandler} />}
    {((stub.svetiljka && !userInfo) || (userInfo && !stub.status)) && <Button type='submit' disabled={(!userInfo) && (!opisK || !email || !enable)}>Submit
    </Button>}
    </Form>
  </Modal.Body>
</Modal>
</div>}
</>
  )
}

export default GoogleApiWrapper({
  apiKey: 'AIzaSyACV2yMJcx_aByY3PwY1b59WvppbM9_ovc'
})(HomeScreen);
